import React from 'react';
import { Box, LinearProgress, Typography } from '@material-ui/core';

const LinearProgressWithLabel: React.FC<{ value: number }> = ({ value }) => {
    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <LinearProgress variant="determinate" value={value} />
            </Box>
            <Box minWidth={35}>
                <Typography variant="body2" color="textSecondary">{`${Math.round(value)}%`}</Typography>
            </Box>
        </Box>
    );
};

export default LinearProgressWithLabel;